module.exports = __webpack_public_path__ + "img/硫酸钡砂.ce37ae83.jpg";